/* @flow */

import $ from 'jquery';
import moment from 'moment';
import get from 'lodash/get';
import swal from '../utils/swal';
import { exibirToastError } from '../utils/alertas';
import { buttonAtivo } from './GridEmpresas';
import labelNivel from '../usuario/label-nivel';
import formatarCpf from '../utils/formatar-cpf';
import formularioUsuario from './formuario-usuario';
import api from '../utils/api';
import { type Usuario } from '../usuario/types';

const thead = `
    <thead>
        <tr>
            <th style="text-align: center;">
                <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">
                        Id
                    </font>
                </font>
            </th>
            <th style="text-align: center;">
                <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">
                        Nível
                    </font>
                </font>
            </th>
            <th style="text-align: center;">
                <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">
                        Nome
                    </font>
                </font>
            </th>
            <th style="text-align: center;">
                <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">
                        E-mail
                    </font>
                </font>
            </th>
            <th style="text-align: center;">
                <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">
                        CPF
                    </font>
                </font>
            </th>
            <th style="text-align: center;">
                <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">
                        Nascimento
                    </font>
                </font>
            </th>
            <th style="text-align: center;">
                <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">
                        Ativo
                    </font>
                </font>
            </th>
            <th style="text-align: center;">
                <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">
                        Entrada
                    </font>
                </font>
            </th>
            <th style="text-align: center;">
                <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">
                        Opções
                    </font>
                </font>
            </th>
        </tr>
    </thead>
`;

const tbody = (usuarios: Usuario[]) => `
    <tbody>
        ${usuarios.map(usuario => (`
            <tr>
                <th scope="row">
                    <font style="vertical-align: inherit;">
                        <font style="vertical-align: inherit;">
                            #${usuario.id}
                        </font>
                    </font>
                </th>
                <td>
                    <font style="vertical-align: inherit;">
                        <font style="vertical-align: inherit;">
                            ${labelNivel(usuario.nivel)}
                        </font>
                    </font>
                </td>
                <td>
                    <font style="vertical-align: inherit;">
                        <font style="vertical-align: inherit;">
                            ${usuario.nome}
                        </font>
                    </font>
                </td>
                <td>
                    <font style="vertical-align: inherit;">
                        <font style="vertical-align: inherit;">
                            ${usuario.email ? usuario.email : ''}
                        </font>
                    </font>
                </td>
                <td>
                    <font style="vertical-align: inherit;">
                        <font style="vertical-align: inherit;">
                            ${formatarCpf(usuario.cpf ? usuario.cpf : '')}
                        </font>
                    </font>
                </td>
                <td>
                    <font style="vertical-align: inherit;">
                        <font style="vertical-align: inherit;">
                        ${moment(usuario.nascimento).format('DD/MM/Y')}
                        </font>
                    </font>
                </td>
                <td>
                    <font style="vertical-align: inherit;">
                        <font style="vertical-align: inherit;">
                        ${buttonAtivo(usuario.ativo)}
                        </font>
                    </font>
                </td>
                <td>
                    <font style="vertical-align: inherit;">
                        <font style="vertical-align: inherit;">
                            ${moment(usuario.cadastro).format('DD/MM/Y')}
                        </font>
                    </font>
                </td>
                <td>
                    <button
                        type="button"
                        class="btn m-btn m-btn--hover-info m-btn--icon m-btn--icon-only m-btn--pill mostrar-em-hover editar-funcionario"
                        title="Editar funcionário"
                    >
                        <input type="hidden" value="${usuario.id}">
                        <i class="m-menu__link-icon flaticon-edit-1"></i>
                    </button>
                </td>
            </tr>
        `)).join('')}
    </tbody>
`;

const semFuncionarios = `
    <div class="alert m-alert alert-warning">
        <div class="m-alert__text">Nenhuma funcionário encontrado</div>
    </div>`;

const setEventEditar = () => {
    const buttons = document.querySelectorAll('.editar-funcionario');
    buttons.forEach((elemento: Object) => {
        elemento.onclick = () => {
            const usuarioId = elemento.querySelector('input').value;
            formularioUsuario(usuarioId);
        };
    });
};

const funcionariosPorEmpresa = async (empresasId: number, fantasia: string) => {
    try {
        const { data: { data: usuarios } } = await api.getUsuarios(
            {
                empresasId,
                nivel: ['A', 'F'],
                origem: 'admin',
                dataInicial: '2017-01-01',
                dataFinal: moment().format('YYYY-MM-DD'),
                quantidade: 10000,
            },
        );

        swal.fire({
            title: `Funcionários da empresa ${fantasia}`,
            width: 1300,
            scrollbarPadding: false,
            confirmButtonColor: '#36a3f7',
            html: `
                <br/>
                <div
                    class="m-section" m-scrollable m-scrollable--track"
                    data-scrollable="true"
                    style="max-height: 400px""
                >
                    <div class="m-section__content">
                        <table class="table m-table m-table--head-bg-brand">
                            ${thead}
                            ${tbody(usuarios)}
                        </table>
                        ${usuarios.length < 1 ? semFuncionarios : ''}
                    </div>
                </div>`,
            focusConfirm: false,
        });

        $(document).ready(() => {
            window.mApp.init();
            setEventEditar();
        });
    } catch (error) {
        exibirToastError(get(
            error,
            'response.data.message',
            'Algo deu errado',
        ));
    }
};

export default funcionariosPorEmpresa;
